var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApps = function SvgApps(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 7a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m-1 5.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0m9 0a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0",
    clipRule: "evenodd"
  })));
};
export default SvgApps;